#import "../fragments/ImageCategorizationFragment.gql"

fragment ImageFragment on Image {
  id
  url
  width
  height
  ...ImageCategorizationFragment
  originalImage {
    id
    url
    width
    height
    types
    organized
  }
}
